import {
  Form, Input, Select, GetProps, SelectProps,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { IconSvg } from 'shared/icon';
import { FormItemWrapper } from 'shared/filter/Filter.styled';
import { SearchItemsWrapper, StyledSearchWrapper } from 'components/styledComponents/search/Search.styled';
import { FormInputWrapper } from 'components/styledComponents/input/Input.styled';
import { StyledIconDefault } from 'shared/icon/Icon.styled';
import { onlyNumbersFormatter } from 'utils/utils';
import { ChangeEvent } from 'react';
import type { FormInstance } from 'antd';
import { StyledSelectWrapper } from 'components/styledComponents/select/Select.styled';

const { Option } = Select;

type AntdSearchProps = GetProps<typeof Input.Search>;

interface SearchOption {
  value: string,
  name: string,
  isNumeric?: boolean,
}

interface SearchProps{
  changeSearchType?: SelectProps['onChange'],
  options: SearchOption[],
  onSearch?: AntdSearchProps['onSearch'],
  label?: string,
  placeholder?: string,
  selectName?: string,
  form: FormInstance,
  inputName:string,
  isInput?: boolean,
  disabled?: boolean,
}

const Search = ({
  changeSearchType, options, onSearch, label, placeholder, selectName, form, inputName, isInput, disabled,
}: SearchProps) => {
  const { t } = useTranslation();

  const { setFieldsValue, getFieldValue } = form;

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const name = getFieldValue(selectName);
    const index = options.findIndex((el) => el.value === name);
    setFieldsValue({ [inputName]: options[index].isNumeric ? onlyNumbersFormatter(event) : event.target.value });
  };

  return (
    <SearchItemsWrapper>
      <FormItemWrapper>
        <Form.Item label={label} name={selectName}>
          <StyledSelectWrapper
            size="large"
            onChange={changeSearchType}
            suffixIcon={(
              <StyledIconDefault>
                <IconSvg icon="DropdownIcon" width="0.7rem" />
              </StyledIconDefault>
            )}
          >
            {options.map((option) => (
              <Option value={option.value} key={option.value}>
                {t(option.name)}
              </Option>
            ))}
          </StyledSelectWrapper>
        </Form.Item>
      </FormItemWrapper>
      <StyledSearchWrapper $isInput={isInput}>
        <FormItemWrapper>
          <FormInputWrapper $isInput>
            <Form.Item name={inputName}>
              {isInput ? (
                <Input onChange={handleChange} placeholder={placeholder} allowClear autoComplete="off" disabled={disabled} />
              ) : (
                <Input.Search onChange={handleChange} onSearch={onSearch} placeholder={placeholder} allowClear autoComplete="off" disabled={disabled} />
              )}
            </Form.Item>
          </FormInputWrapper>
        </FormItemWrapper>
      </StyledSearchWrapper>
    </SearchItemsWrapper>
  );
};

export default Search;
